<div class="px-5 py-5" *ngIf="paisId$ | async as paisId">
  <div class="flex items-center justify-between">
    <div translate class="text-xl font-medium text-theme-950">
      trilhas.estudio.vitrines
      <span class="text-md font-normal text-theme-400">{{ course.titulo }}</span>
    </div>
  </div>
  <div class="-mx-24 my-5 border border-theme-500"></div>
  <div *ngIf="isShowcase; else formShowcase">
    <div class="flex w-full items-center justify-center">
      <button
        (click)="onToggleShowcase()"
        translate
        app-outline-button
        class="mx-5 my-2 w-[90%] rounded-lg bg-[#003249] px-5 py-2 text-theme-50"
        type="button"
      >
        trilhas.estudio.cadastrar-vitrine
      </button>
    </div>
    <div translate class="my-10 text-lg font-bold uppercase text-theme-600">trilhas.estudio.lista-vitrines</div>
    <div class="mt-5 max-h-[50rem] w-full overflow-y-auto">
      <ng-container *ngIf="showcases$ | async as showcases; else noShowcase">
        <ng-container *ngIf="!!showcases.length; else noShowcase">
          <div
            *ngFor="let showcase of showcases"
            class="group/vitrine mb-2 w-full rounded-lg p-5 shadow hover:bg-[#fdfbfd]"
          >
            <div class="flex items-center justify-between">
              <div class="flex w-5/6 flex-wrap items-center justify-start gap-2">
                <p class="text-md font-semibold text-theme-600">{{ showcase.titulo }}</p>
                <p class="text-sm font-light text-theme-900">
                  {{ showcase.tipo[paisId === 1 ? 'descricao' : 'descricao_es'] }}
                </p>
                <div class="flex h-8 w-8 items-center justify-center rounded-full bg-theme-100 text-theme-400">
                  <p class="w-full text-center text-sm font-light text-theme-950">{{ showcase.entidades.length }}</p>
                </div>
                <svg-icon
                  *ngIf="showcase.professor"
                  app-tooltip
                  [tooltip]="'trilhas.estudio.para-professores' | translate"
                  class="texte-theme-500 hover:texte-theme-600 mr-1 flex h-7 w-7 cursor-context-menu p-1 ease-in-out"
                  src="assets/icons/icon-teacher.svg"
                ></svg-icon>
                <svg-icon
                  *ngIf="showcase.gerar_evento"
                  app-tooltip
                  [tooltip]="'trilhas.estudio.para-evento' | translate"
                  class="texte-theme-500 hover:texte-theme-600 mr-1 flex h-7 w-7 cursor-context-menu p-1 ease-in-out"
                  src="assets/icons/icon-menu-showcase.svg"
                ></svg-icon>
                <svg-icon
                  *ngIf="showcase.relatorio"
                  app-tooltip
                  [tooltip]="'trilhas.estudio.acesso-relatorio' | translate"
                  class="texte-theme-500 hover:texte-theme-600 mr-1 flex h-7 w-7 cursor-context-menu p-1 ease-in-out"
                  src="assets/icons/icon-report.svg"
                ></svg-icon>
              </div>
              <div class="flex w-1/6 items-center justify-end">
                <div>
                  <button
                    app-tooltip
                    (click)="onToggleShowcase(showcase)"
                    [tooltip]="'trilhas.estudio.tooltip-editar-vitrine' | translate"
                    type="button"
                  >
                    <svg-icon
                      class="mr-4 flex h-8 w-8 p-1 text-yellow-500 opacity-0 transition-opacity duration-300 ease-in-out hover:text-yellow-600 group-hover/vitrine:opacity-100"
                      src="assets/icons/icon-edit.svg"
                    ></svg-icon>
                  </button>
                </div>
                <div>
                  <button
                    app-tooltip
                    (click)="onDeteleShowcase(showcase.id)"
                    [tooltip]="'trilhas.estudio.tooltip-excluir-vitrine' | translate"
                    type="button"
                  >
                    <svg-icon
                      class="flex h-8 w-8 p-1 text-red-600 opacity-0 transition-opacity duration-300 ease-in-out hover:text-red-500 group-hover/vitrine:opacity-100"
                      src="assets/icons/icon-trash.svg"
                    ></svg-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #noShowcase>
        <div *ngIf="loading$ | async; else jumbotron" app-card-content class="h-[200px] !p-0">
          <app-skeleton></app-skeleton>
        </div>
        <ng-template #jumbotron>
          <app-jumbotron class="min-h-[200px]">{{ 'trilhas.estudio.nenhuma-vitrines' | translate }}</app-jumbotron>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <ng-template #formShowcase>
    <div class="px-10 py-5">
      <form [formGroup]="form">
        <div class="h-[70vh] overflow-y-auto xl:h-[75vh]">
          <app-form-field>
            <label app-label translate>
              <div class="flex items-center gap-2">
                <div translate class="!text-md text-theme-950">trilhas.estudio.titulo</div>
                <div
                  app-tooltip
                  [tooltip]="'trilhas.estudio.tooltip-titulo' | translate"
                  class="flex h-[13px] w-[13px] cursor-pointer items-center justify-center rounded-full border border-black"
                >
                  <span class="text-center text-[10px]">&quest;</span>
                </div>
              </div>
            </label>
            <input app-input formControlName="titulo" class="block leading-5" type="text" />
          </app-form-field>
          <app-form-field>
            <label translate app-label class="!text-md text-theme-950">trilhas.estudio.tipo</label>
            <ng-select
              app-select
              [items]="showcaseTypes$ | async"
              formControlName="tipo"
              [bindLabel]="paisId === 1 ? 'descricao' : 'descricao_es'"
              [placeholder]="'trilhas.estudio.selecione' | translate"
              [clearable]="false"
            >
            </ng-select>
          </app-form-field>
          <div class="mb-10 flex flex-col items-start justify-center gap-6">
            <div class="flex w-full items-center gap-2">
              <app-switch formControlName="professor" [colorTrue]="'bg-theme-300'"></app-switch>
              <label app-label class="!p-0 !text-md text-theme-950" translate>trilhas.estudio.para-professores</label>
            </div>
            <div class="flex w-full items-center gap-2">
              <app-switch formControlName="gerar_evento" [colorTrue]="'bg-theme-300'"></app-switch>
              <label app-label class="!p-0 !text-md text-theme-950" translate>trilhas.estudio.para-evento</label>
            </div>
            <div class="flex w-full items-center gap-2">
              <app-switch formControlName="relatorio" [colorTrue]="'bg-theme-300'"></app-switch>
              <label app-label class="!p-0 !text-md text-theme-950" translate>trilhas.estudio.acesso-relatorio</label>
            </div>
          </div>
          <ng-container *ngIf="entities$ | async as entities; else listEmpty">
            <div
              *ngIf="!!entities.length"
              class="group/section relative mt-5 flex w-full flex-col items-center justify-start rounded-lg border border-dashed border-theme-500 p-5"
            >
              <div class="absolute -top-6 left-5 flex items-center justify-start bg-white">
                <div translate class="ml-2 text-md font-semibold uppercase text-theme-900">
                  trilhas.estudio.selecione-unidades
                </div>
                <div class="ml-2 flex">
                  <button
                    app-input
                    [ngClass]="{ '!rounded-r-none': showInput }"
                    class="flex !h-10 !w-10 items-center justify-center !rounded-full !border-r-0 focus:!border-gray-200"
                    (click)="onToggleInput()"
                  >
                    <svg-icon class="w-4 text-theme-500" src="assets/icons/icon-search.svg"></svg-icon>
                  </button>
                </div>
                <div class="rounded-full rounded-l-none" [ngClass]="{ hidden: !showInput }">
                  <input
                    app-input
                    class="block !h-10 !w-56 !rounded-full !rounded-l-none !border-l-0 !leading-4 focus:!border-gray-200"
                    type="text"
                    [placeholder]="'trilhas.evento.pesquisar' | translate"
                    [formControl]="searchCtrl"
                  />
                </div>
              </div>
              <div class="max-h-[30rem] w-full !overflow-y-auto p-2">
                <ng-container *ngIf="(entities | filter : searchCtrl.value : ['nome']).length > 0; else noResults">
                  <div class="mb-5 mt-2 flex items-center justify-start">
                    <button
                      *ngIf="!isAllChecked(entities) && !hasAnyChecked()"
                      type="button"
                      app-icon-button
                      (click)="onMarkAllEntities(entities)"
                      class="group border border-theme-800 text-theme-800 shadow-md hover:bg-theme-800 hover:text-theme-contrast"
                    >
                      {{ 'trilhas.evento.marcar-todos' | translate }}
                    </button>
                    <button
                      *ngIf="isAllChecked(entities) || hasAnyChecked()"
                      type="button"
                      app-icon-button
                      (click)="onUnmarkAllEntities()"
                      class="group border border-base-status-danger text-base-status-danger shadow-md hover:bg-base-status-danger hover:text-theme-contrast"
                    >
                      {{ 'trilhas.evento.desmarcar-todos' | translate }}
                    </button>
                  </div>
                  <div
                    *ngFor="let entity of entities | filter : searchCtrl.value : ['nome']"
                    class="my-5 flex h-14 w-full items-center justify-start rounded-md p-3 shadow-inner hover:bg-[#fcfcfd]"
                  >
                    <input
                      app-checkbox
                      (click)="onToggleEntityCheckbox($event, entity)"
                      class="text-theme-900"
                      type="checkbox"
                      [checked]="isCheckboxChecked(entity.id)"
                    />
                    <label class="ml-4 cursor-pointer text-md text-theme-900">{{ entity.nome }}</label>
                  </div>
                </ng-container>
                <ng-template #noResults>
                  <app-jumbotron translate class="p-5">
                    <ng-container translate *ngIf="true">
                      <p translate class="text-base text-theme-900">trilhas.estudio.no-results</p>
                    </ng-container>
                  </app-jumbotron>
                </ng-template>
              </div>
            </div>
          </ng-container>
          <ng-template #listEmpty>
            <div
              class="group/section relative mt-5 flex w-full flex-col items-center justify-start rounded-lg border border-dashed border-theme-500 p-5"
            >
              <div class="max-h-[30rem] w-full !overflow-y-auto p-2">
                <app-jumbotron translate class="p-2">
                  <ng-container translate>
                    <p translate class="text-base text-theme-900">
                      trilhas.estudio.carregar-lista<span translate class="text-base font-semibold text-theme-900"
                        >trilhas.estudio.tipo</span
                      >
                    </p>
                  </ng-container>
                </app-jumbotron>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="mt-8 flex items-center justify-between">
          <button
            type="button"
            (click)="onToggleShowcase()"
            app-outline-button
            translate
            class="!h-10 !w-48 border-base-status-danger text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
          >
            trilhas.cancelar
          </button>
          <button
            type="button"
            (click)="onSaveShowcase()"
            app-outline-button
            translate
            class="group w-48 border-theme-800 text-theme-800 shadow-md hover:bg-theme-800 hover:text-theme-contrast"
          >
            trilhas.salvar
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</div>
